/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3MetricsIngressBandwidthRequest = {
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Float Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3MetricsIngressBandwidthRequest$inboundSchema: z.ZodType<
  GetApiV3MetricsIngressBandwidthRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  end: z.nullable(z.number()).default(null),
  start: z.nullable(z.number()).default(null),
  step: z.number().default(7200),
});

/** @internal */
export type GetApiV3MetricsIngressBandwidthRequest$Outbound = {
  end: number | null;
  start: number | null;
  step: number;
};

/** @internal */
export const GetApiV3MetricsIngressBandwidthRequest$outboundSchema: z.ZodType<
  GetApiV3MetricsIngressBandwidthRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3MetricsIngressBandwidthRequest
> = z.object({
  end: z.nullable(z.number()).default(null),
  start: z.nullable(z.number()).default(null),
  step: z.number().default(7200),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsIngressBandwidthRequest$ {
  /** @deprecated use `GetApiV3MetricsIngressBandwidthRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsIngressBandwidthRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsIngressBandwidthRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsIngressBandwidthRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsIngressBandwidthRequest$Outbound` instead. */
  export type Outbound = GetApiV3MetricsIngressBandwidthRequest$Outbound;
}

export function getApiV3MetricsIngressBandwidthRequestToJSON(
  getApiV3MetricsIngressBandwidthRequest:
    GetApiV3MetricsIngressBandwidthRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsIngressBandwidthRequest$outboundSchema.parse(
      getApiV3MetricsIngressBandwidthRequest,
    ),
  );
}

export function getApiV3MetricsIngressBandwidthRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3MetricsIngressBandwidthRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsIngressBandwidthRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3MetricsIngressBandwidthRequest' from JSON`,
  );
}
